// removed by extract-text-webpack-plugin
module.exports = {"qrSignUpPage":"QRSignUp__qrSignUpPage","title":"QRSignUp__title","endContainer":"QRSignUp__endContainer","options":"QRSignUp__options","rememberMe":"QRSignUp__rememberMe","already":"QRSignUp__already","logo":"QRSignUp__logo","growDotQello":"QRSignUp__growDotQello","growDotBlue":"QRSignUp__growDotBlue","growDotGolden":"QRSignUp__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/QRSignUp/QRSignUp.scss
// module id = 1913
// module chunks = 0